// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/info-outline-thin.svg';

export const InfoOutlineThin = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
